
  import { css } from 'lit';
  export const styles = css`:host{--resize-indicator: var(--ig-resize-indicator-resize-indicator, var(--ig-primary-300));--ig-theme: indigo;--ig-theme-variant: dark}`;
  